import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

import Login from './pages/Login';
import Register from './pages/Register';
import Home from './pages/Home'; // NEW: Chronos-powered Dashboard
import './index.css';

import MemoryGame from './pages/games/MemoryGame';
import MathGame from './pages/games/MathGame';
import WordGame from './pages/games/WordGame';
import NumberMemory from './pages/games/NumberMemory';
import FocusGame from './pages/games/FocusGame';
import SynonymSync from './pages/games/SynonymSync';
import AdminDashboard from './pages/admin/AdminDashboard';
import ProtectedRoute from './components/ProtectedRoute';
import BadgeCollection from './components/BadgeCollection';
import Upgrade from './pages/Upgrade';
import Contact from './pages/Contact';
import Leaderboard from './pages/Leaderboard';
import Profile from './pages/Profile';
import BrainTest from './pages/admin/BrainTest';
import MathSprint from './pages/games/MathSprint'; // adjust path if needed
import LogicGame from './pages/games/LogicGame';
import QuickTap from './pages/games/QuickTap';
import BuddyBot from './pages/BuddyBot';
import AskBuddy from './pages/AskBuddy';
import './i18n';


import PlayerReport from './pages/admin/PlayerReport';
import PrivacyPolicy from './pages/PrivacyPolicy';

import BookSummaryPage from "./pages/BookSummaryPage"; // adjust path as needed
import BookQuizPage from "./pages/BookQuizPage";
import BookQuestionPage from "./pages/BookQuestionPage";



function App() {
  return (
    <Router>
      <Routes>
        {/* Auth */}
        <Route path="/admin" element={<ProtectedRoute adminOnly={true}>  
          <AdminDashboard />  </ProtectedRoute>
  }/>
        <Route path="/" element={<Login />} />
        <Route path="/register" element={<Register />} />
        {/* Brain Test page */}
        <Route path="/admin/brain-test" element={
  <ProtectedRoute adminOnly={true}>
    <BrainTest />
  </ProtectedRoute>
} />
        {/* Upgarde page */}
        <Route path="/upgrade" element={<Upgrade />} />
        {/* Main Dashboard */}
        <Route path="/home" element={<Home />} /> {/* Previously 'Dashboard' */}
        {/* Contact */}
        <Route path="/contact" element={<Contact />} />
        {/* Games */}
        <Route path="/game/memory" element={<MemoryGame />} />
        <Route path="/game/math" element={<MathGame />} />
        <Route path="/game/word" element={<WordGame />} />
        <Route path="/game/number-memory" element={<NumberMemory />} />
        <Route path="/game/focus" element={<FocusGame />} />
        <Route path="/game/synonym" element={<SynonymSync />} />
        <Route path="/game/quicktap" element={<QuickTap />} />
        <Route path="/leaderboard" element={<Leaderboard />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/badges" element={<BadgeCollection />} />
        <Route path="/game/math-sprint" element={<MathSprint />} />
        <Route path="/game/logic" element={<LogicGame />} />
        <Route path="/admin/player-report/:id" element={<PlayerReport />} />
        <Route path="/BuddyBot" element={<BuddyBot />} />
        <Route path="/ask-buddy" element={<AskBuddy />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
         <Route path="/book-summary/:bookname" element={<BookSummaryPage />} />
        <Route path="/book-quiz/:bookname" element={<BookQuizPage />} />
        <Route path="/book-question/:bookname" element={<BookQuestionPage />} />






      </Routes>
    </Router>
  );
}

export default App;
